<template>
  <table class="striped admin-vendors-table">
    <caption v-html="caption" v-if="caption" />
    <colgroup>
      <col width="50%" />
      <col width="50%" />
    </colgroup>
    <thead>
      <tr>
        <th>Supplier</th>
        <th>Manufacturer</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="vendor in paginatedVendors"
        :key="vendor.id"
        :class="selectedId === vendor.id ? 'selected' : 'selectable'"
        @click="handleSelect(vendor)"
      >
        <td>{{ vendor.name }}</td>
        <td>{{ (vendor.manufacturer || {}).name }}</td>
      </tr>
      <tr v-if="vendors.length === 0">
        <td class="no-records" colspan="2">
          There are currently no vendors in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls" colspan="2">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("vendors")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
    vendors: {
      type: Array,
    },
  },

  methods: {
    handleSelect(vendor) {
      this.$emit("select", vendor);
    },
  },
};
</script>